<template>
  <div class="space-y-4">
    <h4 class="font-bold text-lg text-gray-900">Delivery Address</h4>
    <div class="space-y-3">
      <div>
        <label
          class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5"
        >
          Address Line 1 *
        </label>
        <input
          ref="addressLine1Input"
          :value="address.addressLine1"
          @input="handleInput('addressLine1', $event.target.value)"
          type="text"
          placeholder="Street address"
          :class="[
            'w-full px-4 py-2.5 border rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-all',
            addressError
              ? 'border-red-500 focus:ring-red-200'
              : 'border-gray-200 focus:ring-primary-500'
          ]"
        />
        <p v-if="addressError" class="mt-1 text-xs text-red-500">
          This field is required
        </p>
      </div>
      <div>
        <label
          class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5"
        >
          Address Line 2
        </label>
        <input
          :value="address.addressLine2"
          @input="handleInput('addressLine2', $event.target.value)"
          type="text"
          placeholder="Apartment, suite, etc. (optional)"
          class="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
        />
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <label
            class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5"
          >
            City
          </label>
          <input
            :value="address.city"
            @input="handleInput('city', $event.target.value)"
            type="text"
            placeholder="City"
            class="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
          />
        </div>
        <div>
          <label
            class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5"
          >
            State
          </label>
          <input
            :value="address.state"
            @input="handleInput('state', $event.target.value)"
            type="text"
            placeholder="State"
            class="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
          />
        </div>
      </div>
      <div>
        <label
          class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5"
        >
          ZIP Code
        </label>
        <input
          :value="address.zip"
          @input="handleInput('zip', $event.target.value)"
          type="text"
          placeholder="ZIP code"
          class="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { saveDeliveryAddress } from "@/services/localStorageService";

export default {
  name: "DeliveryAddressForm",
  props: {
    address: {
      type: Object,
      required: true
    },
    addressError: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(field, value) {
      // Emitir el evento de actualización usando .sync style o v-model:address
      this.$emit("update:address", { ...this.address, [field]: value });
      this.$emit("address-input"); // Para limpiar el error

      // Persistencia inmediata
      saveDeliveryAddress({ ...this.address, [field]: value });
    },
    focusAddressLine1() {
      this.$nextTick(() => {
        if (this.$refs.addressLine1Input) {
          this.$refs.addressLine1Input.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
          this.$refs.addressLine1Input.focus();
        }
      });
    }
  }
};
</script>
